<template>
  <header class="header">
    <div class="container">
      <div class="header__wrapper">
        <router-link :to="{ name: 'home' }">
          <img class="header__logo" src="@images/logo.png" alt="logo">
        </router-link>
        <nav class="header__nav">
          <p class="header__nav-item" @click="scrollTo('why', 'home')">Why Us?</p>
          <p class="header__nav-item" @click="scrollTo('hello', 'home')">Who We Are</p>
          <p class="header__nav-item" @click="scrollTo('solutions', 'home')">Our Solutions</p>
        </nav>
        <button class="header__button" @click="scrollTo('contact', 'home')">CONTACT US</button>
      </div>
    </div>
  </header>
</template>

<script setup>
import {scroll} from "@/core/helpers/scrollTo.js";
import {useRoute, useRouter} from "vue-router";

const router = useRouter()
const route = useRoute()

const scrollTo = (id, routeName) => {
  if (route.name === routeName) {
    scroll(id);
  } else {
    router.push({
      name: 'home'
    }).then(scroll(id));
  }
}
</script>

<style lang="scss" scoped>
.header {
  position: fixed;
  width: 100%;
  z-index: 10;
  padding-block: 14px;
  box-shadow: 0 1px 0 0 #E1E3E5;
  background-color: $white;

  &__wrapper {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  &__logo {
    
  }

  &__nav {
    display: flex;
    align-items: center;
    gap: 32px;

    &-item {
      cursor: pointer;
      color: #636270;
      font-size: 14px;
      font-weight: 500;
      text-transform: capitalize;

      @include hover {
        color: #42414b;
      }
    }
  }

  &__button {
    cursor: pointer;
    background-color: transparent;
    transition: 0.2s;

    color: #007580;
    font-size: 16px;
    font-weight: 700;
    text-transform: capitalize;
  }
}

@media (max-width: 650px) {
  .header {
    &__wrapper {
      padding-bottom: 40px;
      position: relative;
    }

    &__nav {
      position: absolute;
      bottom: 0;
      left: 50%;
      transform: translateX(-50%);
      width: 100%;
      justify-content: center;

      &-item {
        flex-shrink: 0;
      }
    }
  }
}
</style>